import store from '@/store'

const requireRecProcessRules = (to, from, next) => {
  const hasOption = store?.state?.auth?.account?.options?.includes('rec_process_rules')
  if (hasOption) {
    next()
  } else {
    next({ name: 'PurchaseList' })
  }
}

const supplierRoutes = [
  {
    path: '/:prefix(test)?/suppliers/categories/:id/add-suppliers',
    name: 'SuppliersCategoriesAddSuppliers',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'PurchaseList',
      requireAuth: true,
      requireAccount: true,
      title: 'Agregar proveedores a categoría'
    },
    beforeEnter: requireRecProcessRules,
    component: () => import('@/modules/supplier/categories/views/SuppliersCategoriesAddSuppliers')
  },
  {
    path: '/:prefix(test)?/suppliers/categories/:id',
    name: 'SuppliersCategoriesRetrieveUpdate',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'PurchaseList',
      requireAuth: true,
      requireAccount: true,
      title: 'Informacion de la categoria - Proveedores'
    },
    beforeEnter: requireRecProcessRules,
    component: () => import('@/modules/supplier/categories/views/SuppliersCategoriesRetrieveUpdate')
  },
  {
    path: '/:prefix(test)?/suppliers/categories',
    name: 'SuppliersCategoriesList',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'PurchaseList',
      requireAuth: true,
      requireAccount: true,
      title: 'Categorias - Proveedores'
    },
    beforeEnter: requireRecProcessRules,
    component: () => import('@/modules/supplier/categories/views/SuppliersCategoriesList')
  },
  {
    path: '/:prefix(test)?/suppliers',
    name: 'SupplierListCreate',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'PurchaseList',
      requireAuth: true,
      requireAccount: true,
      title: 'Proveedores'
    },
    beforeEnter: requireRecProcessRules,
    component: () => import('@/modules/supplier/views/SupplierListCreate')
  },
  {
    path: '/:prefix(test)?/suppliers/:id',
    name: 'SupplierRetrieveUpdate',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'PurchaseList',
      requireAuth: true,
      requireAccount: true,
      title: 'Detalles y actualizacion de proveedores'
    },
    beforeEnter: requireRecProcessRules,
    component: () => import('@/modules/supplier/views/Main')
  }
]
export default supplierRoutes
